import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportContent from "./content/report-content.jsx";

export default function Content({ reportData, data, entity, title, printComponentRef, setIsLoading }) {
    return (
        <>
            {reportData && data && (
                <PrintTemplate
                    entity={entity}
                    title={title}
                    ref={printComponentRef}
                    setIsPrinting={setIsLoading}
                >
                    <div id="filters-print" className="transform !-translate-y-[8.5px]" />
                    <div className="print:border-b print:border-gray-200 print:mb-6 print:w-full" />
                    <div className="w-full mt-[25px] print:mt-0">
                        <ReportContent data={reportData} />
                    </div>
                </PrintTemplate>
            )}
        </>
    )
}